import React from 'react';
import PropTypes from 'prop-types';
import './NewAudiencesModal.scss';
import BaseModal from 'react/components/common/Modal/BaseModal/BaseModal';
import SubmitButton from 'react/components/common/SubmitButton/SubmitButton';

const NewAudiencesModal = ({ isOpen, onClose, audiences }) => {
  if (!isOpen) return null;
  return (
    <div className="new-audiences-modal">
      {/* titleMargin overrides BaseModal's 30px default to the 15px the delete-audience popup uses. */}
      <BaseModal
        isOpen={isOpen}
        modalTitle="New Audiences"
        onXClick={onClose}
        isLightTheme={true}
        width="440px"
        titleMargin="0 0 15px 0"
      >
        <div className="new-audiences-modal__body">
          <p className="new-audiences-modal__intro">
            The following audiences were created and activated according to the selected options:
          </p>
          {audiences.map(({ audienceName, activatedTypes }) => (
            <div className="new-audiences-modal__audience" key={audienceName}>
              <div className="new-audiences-modal__name">{audienceName}</div>
              {/* A source can be split off the parent without being activated (none of its activation
                  types were selected). It still exists in its own source, so say so instead of
                  listing nothing. */}
              <div className="new-audiences-modal__types">
                {activatedTypes.length > 0 ? `Activated: ${activatedTypes.join(', ')}` : 'Created, not activated'}
              </div>
            </div>
          ))}
          <p className="new-audiences-modal__footer">Each audience can be found in its original source.</p>
          <div className="new-audiences-modal__done">
            <SubmitButton label="Done" onClick={onClose} isLightTheme={true} />
          </div>
        </div>
      </BaseModal>
    </div>
  );
};

NewAudiencesModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  audiences: PropTypes.arrayOf(
    PropTypes.shape({
      audienceName: PropTypes.string.isRequired,
      activatedTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
    })
  ),
};

NewAudiencesModal.defaultProps = {
  isOpen: false,
  audiences: [],
};

export default NewAudiencesModal;
